// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"279":"59935048","502":"c47f6083"}[chunkId] + ".chunk.css";
};